import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



export default function Modal(props) {

  const { handleClose, title, paperStyle = {}, className, maxWidth = "md", screenFull = false, showTitle = true, showCloseIcon = true, open } = props;


  return (

    <Dialog
      className={className}
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth={true}
      PaperProps={{
        sx: paperStyle,
      }}
      maxWidth={maxWidth}
      fullScreen={screenFull || false}
      open={open}
    >
      {showTitle && <DialogTitle className="dialogHeader" onClose={handleClose}>
        {title}
      </DialogTitle>}
      {showCloseIcon ? (
        <IconButton
          className="position-absolute right-8 top-2"

          onClick={handleClose}

        >
          <CloseIcon variant="btnIcon" />
        </IconButton>
      ) : null}

      <DialogContent className="padding-0">
        {props.children}
      </DialogContent>
    </Dialog>

  );
}
